(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('axios')) : typeof define === 'function' && define.amd ? define(['exports', 'axios'], factory) : factory(global['bit-util'] = {}, global.axios);
})(this, function (exports, axios) {
  'use strict';

  axios = axios && axios.hasOwnProperty('default') ? axios['default'] : axios;

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var defineProperty = function defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  };

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();
  /**
   * @file 格式化日期和百度上报
   * @author maofaming(229894116@qq.com)
   * @module util/index
   */


  function urlParse(str) {
    var result = {};
    var array = str.split('&');
    array.forEach(function (item) {
      var _item$split = item.split('='),
          _item$split2 = slicedToArray(_item$split, 2),
          key = _item$split2[0],
          _item$split2$ = _item$split2[1],
          value = _item$split2$ === undefined ? '' : _item$split2$;

      try {
        result[key] = decodeURIComponent(value);
      } catch (e) {
        console.error(e);
      }
    });
    return result;
  }

  function urlStringify(obj) {
    var array = [];

    for (var i in obj) {
      try {
        array.push(i + '=' + encodeURIComponent(obj[i]));
      } catch (e) {
        console.error(e);
      }
    }

    return array.join('&');
  }
  /**
   * 百度统计数据上报
   * @param {string} category
   * @param {string} action
   * @param {string} opt_label
   * @param {string} opt_value
   */


  function bdReport(category, action, opt_label, opt_value) {
    window._hmt && window._hmt.push(['_trackEvent', category, action, opt_label, opt_value]);
  }

  function isBrowser() {
    return (typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object';
  }

  var util =
  /*#__PURE__*/
  Object.freeze({
    urlParse: urlParse,
    urlStringify: urlStringify,
    bdReport: bdReport,
    isBrowser: isBrowser
  });
  /**
   * @file 正则校验规则库
   * @author Cold <coldxu_xu@xiaoyunquegroup.com>, jason <jason_cao@xiaoyunquegroup.com>
   * @module util/validator
   */
  //校验器

  var REGEX = {
    intege: '^-?[1-9]\\d*$',
    //整数
    intege1: '^[1-9]\\d*$',
    //正整数
    intege2: '^-[1-9]\\d*$',
    //负整数
    num: '^([+-]?)\\d*\\.?\\d+$',
    //数字
    num1: '^[1-9]\\d*|0$',
    //正数（正整数 + 0）
    num2: '^-[1-9]\\d*|0$',
    //负数（负整数 + 0）
    decmal: '^([+-]?)\\d*\\.\\d+$',
    //浮点数
    decmal1: '^[1-9]\\d*.\\d*|0.\\d*[1-9]\\d*$',
    //正浮点数
    decmal2: '^-([1-9]\\d*.\\d*|0.\\d*[1-9]\\d*)$',
    //负浮点数
    decmal3: '^-?([1-9]\\d*.\\d*|0.\\d*[1-9]\\d*|0?.0+|0)$',
    //浮点数
    decmal4: '^[1-9]\\d*.\\d*|0.\\d*[1-9]\\d*|0?.0+|0$',
    //非负浮点数（正浮点数 + 0）
    decmal5: '^(-([1-9]\\d*.\\d*|0.\\d*[1-9]\\d*))|0?.0+|0$',
    //非正浮点数（负浮点数 + 0）
    email: '^\\w+((-\\w+)|(\\.\\w+))*\\@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$',
    //邮件
    color: '^[a-fA-F0-9]{6}$',
    //颜色
    url: '^http[s]?:\\/\\/([\\w-]+\\.)+[\\w-]+([\\w-./?%&=]*)?$',
    //url
    website: '^([\\w-]+\\.)+[\\w-]+([\\w-./?%&=]*)?$',
    //website
    chinese: "^[\\u4E00-\\u9FA5\\uF900-\\uFA2D]+$",
    //仅中文
    ascii: '^[\\x00-\\xFF]+$',
    //仅ACSII字符
    zipcode: '^\\d{6}$',
    //邮编
    mobile: '1\\d{10}$',
    //手机
    ip4: '^(25[0-5]|2[0-4]\\d|[0-1]\\d{2}|[1-9]?\\d)\\.(25[0-5]|2[0-4]\\d|[0-1]\\d{2}|[1-9]?\\d)\\.(25[0-5]|2[0-4]\\d|[0-1]\\d{2}|[1-9]?\\d)\\.(25[0-5]|2[0-4]\\d|[0-1]\\d{2}|[1-9]?\\d)$',
    //ip地址
    notempty: '^\\S+$',
    //非空
    picture: '(.*)\\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$',
    //图片
    rar: '(.*)\\.(rar|zip|7zip|tgz)$',
    //压缩文件
    date: '^\\d{4}(\\-|\\/|\\.)\\d{1,2}\\1\\d{1,2}$',
    //日期
    qq: '^[1-9][0-9]{4,14}$',
    //QQ号码
    // tel: '^(([0\\+]\\d{2,3}-)?(\\d{2,4})-)?(\\d{7,8})(-(\\d{3,}))?$', //电话号码的函数(包括验证国内区号,国际区号,分机号)'^(([0\\+]\\d{2,3}-)?(0\\d{2,3})-)?(\\d{7,8})(-(\\d{3,}))?$'
    tel: '^0\\d{2,3}-\\d{7,8}$',
    // 区号：前面一个0，后面跟2-3位数字;电话号码：7-8位数字;分机号：一般都是3位数字:/^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/
    telcountry: '^\\+?\\d{1,4}$',
    //电话号码的国家区号号+86
    telarea: '\\d{1,4}$',
    //电话号码的地区区号
    telnumber: '^\\d{7,8}$',
    //电话号码
    username: '^\\w+$',
    //用来用户注册。匹配由数字、26个英文字母或者下划线组成的字符串
    letter: '^[A-Za-z]+$',
    //字母
    letter_u: '^[A-Z]+$',
    //大写字母
    letter_l: '^[a-z]+$',
    //小写字母
    nickname: "^[\u4E00-\u9FA5A-Za-z0-9_]+$",
    password: '^[A-Za-z0-9]{6,20}|[!@#$%^&*()_+|{}?]$',
    //密码
    jd: "^[\u4E00-\u9FA5]{4,20}$|^[\\dA-Za-z_\\-]{4,20}$",
    // 京东账号：支持中文、字母、数字、“-”“_”的组合，4-20个字符
    idCard: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
  };

  function isValid(type, value) {
    return new RegExp(REGEX[type]).test(value);
  }

  var validator =
  /*#__PURE__*/
  Object.freeze({
    REGEX: REGEX,
    isValid: isValid
  });
  /**
   * @file 格式化日期对象
   * @author maofaming(229894116@qq.com)
   * @module util/format
   */

  /**
   * 格式化日期
   * @param {string|number} date - 日期时间
   * @param {string} fmt - 处理格式，默认为：YYYY-MM-DD HH:mm:ss
   * @return {string} 格式化后日期
   */

  function dateFormat(date) {
    var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';

    if (!date) {
      return '';
    }

    if (typeof date === 'string') {
      date = new Date(date.replace(/-/g, '/'));
    }

    if (typeof date === 'number') {
      date = new Date(date);
    }

    var o = {
      'M+': date.getMonth() + 1,
      'D+': date.getDate(),
      'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      'S': date.getMilliseconds()
    };
    var week = {
      '0': "\u65E5",
      '1': "\u4E00",
      '2': "\u4E8C",
      '3': "\u4E09",
      '4': "\u56DB",
      '5': "\u4E94",
      '6': "\u516D"
    };

    if (/(Y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length > 1 ? RegExp.$1.length > 2 ? "\u661F\u671F" : "\u5468" : '') + week[date.getDay() + '']);
    }

    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
      }
    }

    return fmt;
  }

  var version = "2.0.16";
  var COMMON_ENV = {
    DEV: 'development',
    QA: 'testing',
    PRE: 'preview',
    PRD: 'production'
  };
  var NODE_ENV = process.env.NODE_ENV || COMMON_ENV.DEV;
  var API_ENV = process.env.VUE_APP_API || COMMON_ENV.DEV;
  var UA_KEY = 'beenews';
  var APP_CALL = 'beenews://beekan.org/app';
  var HEADER_KEY = {
    AUTH: 'Authorization',
    DEVICE: 'deviceId',
    TS: 'beeTs',
    VERSION: 'beeVersion',
    APP: 'appName',
    TYPE: 'beeOsType'
  };
  var METHOD = {
    GET: 'get',
    POST: 'post',
    DELETE: 'delete',
    PUT: 'put',
    PATCH: 'patch',
    HEAD: 'head',
    OPTIONS: 'options'
  };
  var DEFAULT_SPACE = '/articles/api/{v1}/{client}/{channel}';
  var DEFAULT_PATH_MAP = {
    v1: 'v1',
    client: 'w1',
    channel: 'bkb',
    appcode: 'link',
    uin: 'ft'
  };
  var ONE_SECOND = 1000;
  var ONE_MINUTE = ONE_SECOND * 60;
  var ONE_HOUR = ONE_MINUTE * 60;
  var ONE_DAY = ONE_HOUR * 24;
  var DATETIME = {
    ONE_SECOND: ONE_SECOND,
    ONE_MINUTE: ONE_MINUTE,
    ONE_HOUR: ONE_HOUR,
    ONE_DAY: ONE_DAY
  };
  var defaultConfig = {
    COMMON_ENV: COMMON_ENV,
    NODE_ENV: NODE_ENV,
    API_ENV: API_ENV,
    UA_KEY: UA_KEY,
    APP_CALL: APP_CALL,
    HEADER_KEY: HEADER_KEY,
    METHOD: METHOD,
    DEFAULT_SPACE: DEFAULT_SPACE,
    DEFAULT_PATH_MAP: DEFAULT_PATH_MAP,
    DATETIME: DATETIME
  };

  function setConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return defaultConfig = _extends({}, defaultConfig, config);
  }

  function getConfig() {
    return defaultConfig;
  }

  function detectGenerate() {
    var config = getConfig();
    var uaReg = new RegExp(config.UA_KEY);
    var ua = isBrowser() ? navigator.userAgent : '',
        // 获取ua
    ucbrowser = isBrowser() ? window.ucweb || window.ucbrowser : '',
        os = {},
        browser = {},
        webkit = ua.match(/WebKit\/([\d.]+)/),
        android = ua.match(/(Android)\s+([\d.]+)/),
        ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        kindle = ua.match(/Kindle\/([\d.]+)/),
        silk = ua.match(/Silk\/([\d._]+)/),
        uc = ua.match(/UC/) || ucbrowser,
        wechat = ua.match(/MicroMessenger/),
        weibo = ua.match(/Weibo/),
        qq = ua.match(/QQ/),
        bee_ios = iphone && ua.match(uaReg),
        bee_android = android && ua.match(uaReg);
    browser.webkit = !!webkit;

    if (browser.webkit) {
      browser.version = webkit[1];
    }

    if (android) {
      os.android = true;
      os.version = android[2];
    }

    if (iphone) {
      os.ios = os.iphone = true;
      os.version = iphone[2].replace(/_/g, '.');
    }

    if (ipad) {
      os.ios = os.ipad = true;
      os.version = ipad[2].replace(/_/g, '.');
    }

    if (kindle) {
      os.kindle = true;
      os.version = kindle[1];
    }

    if (silk) {
      browser.silk = true;
      browser.version = silk[1];
    }

    if (!silk && os.android && ua.match(/Kindle Fire/)) {
      browser.silk = true;
    }

    if (uc) {
      browser.uc = true;
      var ucstr = ua.substring(ua.indexOf('UC'), ua.length);
      var uclen = ucstr.indexOf(' ');
      uclen = uclen > -1 ? uclen : ucstr.length;
      browser.version = ucstr.substring(ucstr.indexOf('/') + 1, uclen);
    }

    if (wechat) {
      browser.wechat = true;
    }

    if (weibo) {
      browser.weibo = true;
    }

    if (qq) {
      browser.qq = true;
    }

    if (!android && !ipad && !iphone && !kindle && !silk && !wechat && !uc && !weibo && !qq) {
      browser.desktop = true;
    } // 添加app的浏览器检测


    if (bee_ios) {
      browser.ios = true;
      browser.app = true;
    }

    if (bee_android) {
      browser.android = true;
      browser.app = true;
    }

    return {
      browser: browser,
      os: os
    };
  }
  /**
   * @file js与app通信sdk组件库
   * @author maofaming(229894116@qq.com)
   */


  function dsBridgeGenerate() {
    var detect = detectGenerate();
    var dsBridge = {}; // 引入js与native通信组件库dsbridge

    var noop = function noop() {};

    if (!detect.browser.app) {
      dsBridge = {
        register: noop,
        call: noop,
        registerAsyn: noop,
        hasNativeMethod: noop,
        disableJavascriptDialogBlock: noop
      };
    } else {
      dsBridge = require('dsbridge');
    }

    return dsBridge;
  }
  /**
   * @file js与app通信sdk组件库
   * @author maofaming(229894116@qq.com)
   */


  function sdkGenerate() {
    var dsBridge = dsBridgeGenerate();

    var _detectGenerate = detectGenerate(),
        browser = _detectGenerate.browser;

    var _getConfig = getConfig(),
        APP_CALL = _getConfig.APP_CALL;
    /**
     * @namespace
     */


    return {
      /**
       * 调用api方法 同步或异步的调用Java API。
       * @param {string} method Java API 名称， 可以包含命名空间。
       * @param {string} arg 传递给Java API 的参数。只能传一个，如果需要多个参数时，可以合并成一个json对象参数。
       * @param {function} callback(String) 处理Java API的返回结果. 可选参数，只有异步调用时才需要提供.
       */
      call: function call(method, arg, callback) {
        return dsBridge.call(method, arg, callback);
      },

      /**
       * 注册同步Javascript API
       * @param {string} methodName
       * @param {Object} synApiObject
       */
      register: function register(methodName, synApiObject) {
        dsBridge.register(methodName, synApiObject);
      },

      /**
       * 注册异步Javascript API
       * @param methodName
       * @param synApiObject
       */
      registerAsyn: function registerAsyn(methodName, synApiObject) {
        dsBridge.registerAsyn(methodName, synApiObject);
      },

      /**
       * 检测Java中是否存在名为handlerName的API
       * @param handlerName 可以包含命名空间
       * @param type 可选参数，["all"|"syn"|"asyn" ], 默认是 "all"
       *
       * 检测是否存在一个名为'testAsyn'的API(无论同步还是异步)
       * dsBridge.hasNativeMethod('testAsyn')
       * 检测test命名空间下是否存在一个’testAsyn’的API
       * dsBridge.hasNativeMethod('test.testAsyn')
       * 检测是否存在一个名为"testSyn"的异步API
       * dsBridge.hasNativeMethod('testSyn','asyn') //false
       */
      hasMethod: function hasMethod(handlerName, type) {
        if (type) {
          return dsBridge.hasNativeMethod(handlerName, [type]);
        } else {
          return dsBridge.hasNativeMethod(handlerName);
        }
      },

      /**
       * 禁止Javascript对话框阻塞
       * @param disable
       *
       * dwebview.disableJavascriptDialogBlock(true);
       */
      disableJavascriptDialogBlock: function disableJavascriptDialogBlock(disable) {
        dsBridge.disableJavascriptDialogBlock(disable);
      },

      /**
       * 显示导航返回 android
       *
       * @param {boolean} bool 是否显示导航返回
       */
      showNavBack: function showNavBack(bool) {
        if (browser.ios) {
          // 对ios做兼容处理，大于1.1.3时true为显示，小于是false为显示
          var appVersion = this.getVersion();

          if (this.compareVersion(appVersion, '1.1.3') > 0) {
            // 不显示返回
            this.call('view.showNavBack', bool);
          } else {
            this.call('view.showNavBack', !bool);
          }
        }

        this.call('view.showNavBack', bool);
      },

      /**
       * 显示导航分享
       *
       * @param {boolean} bool 是否显示导航分享
       */
      showNavShare: function showNavShare(bool) {
        this.call('view.showNavShare', bool);
      },

      /**
       * 显示底部分享
       *
       * @param {boolean} bool 是否显示底部分享
       */
      showBottomShare: function showBottomShare(bool) {
        this.call('view.showBottomShare', bool);
      },

      /**
       * 显示显示踩和赞
       *
       * @param {boolean} bool 是否显示踩和赞
       */
      showLikeGroup: function showLikeGroup(bool) {
        this.call('view.showLikeGroup', bool);
      },

      /**
       * 设置id
       *
       * @param {string} id 文章id
       */
      setArticleId: function setArticleId(id) {
        this.call('view.setArticleId', id);
      },

      /**
       * 显示分享
       *
       * @param {Object} info 分享参数， 可选
       *
       */
      shareEvent: function shareEvent(info) {
        if (info && (typeof info === 'undefined' ? 'undefined' : _typeof(info)) === 'object') {
          this.setShareInfo(info);
        }

        if (browser.ios) {
          this.call('view.shareEvent', 1);
        } else {
          this.call('view.share');
        }
      },

      /**
       * 设置点赞数
       *
       * @param {number} num 点赞数
       */
      setLikeCount: function setLikeCount(num) {
        this.call('view.setLikeCount', num);
      },

      /**
       * 设置点踩数
       *
       * @param {number} num 点踩数
       */
      setDislikeCount: function setDislikeCount(num) {
        this.call('view.setDislikeCount', num);
      },

      /**
       * 设置用户是否赞
       *
       * @param {boolean} bool 是否显示赞
       */
      setLiked: function setLiked(bool) {
        this.call('view.setLiked', bool);
      },

      /**
       * 设置用户是否踩
       *
       * @param {boolean} bool 是否显示踩
       */
      setDisliked: function setDisliked(bool) {
        this.call('view.setDisliked', bool);
      },

      /**
       * 设置banner标题
       *
       * @param {string} str 标题文案
       */
      setTitle: function setTitle(str) {
        this.call('view.setTitle', str);
      },

      /**
       * 检查更新
       *
       */
      checkUpdate: function checkUpdate() {
        this.call('view.checkUpdate');
      },

      /**
       * 设置ios  当前webview窗口高度
       *
       * @param {Object} params 分享参数
       * @param {number} params.height
       * @param {number} params.title
       * @param {number} params.contentHeight
       */
      h5HeightCallback: function h5HeightCallback(params) {
        this.call('view.h5HeightCallback', params);
      },

      /**
       * 设置toast提示
       *
       * @param {string} str 提示文案
       */
      toast: function toast(str) {
        this.call('view.toast', str);
      },

      /**
       * 设置APP交互唤起分享微信参数
       *
       * @param {Object} params 分享参数
       * @param {string} params.id 资讯id
       * @param {string} params.type 分享回调统计
       * @param {string} params.title 分享出去的标题
       * @param {string} params.desc 分享出去的简介
       * @param {string} params.imageUrl 分享出去的图标
       * @param {string} params.shareUrl 分享出去的h5地址
       * @param {string} params.shareAlert 分享的提示
       * @param {string} params.shareSubAlert 分享的二级提示
       *
       */
      setShareInfo: function setShareInfo(params) {
        this.call('view.setShareInfo', params);
      },

      /**
       * 设置APP交互唤起分享图片
       *
       * @param {Object} params 分享参数
       * @param {string} params.id 资讯id
       * @param {string} params.desc 弹框描述
       */
      shareImage: function shareImage(params) {
        this.call('view.shareImage', params);
      },

      /**
       * 设置关注回调，更新native关注状态
       *
       * @param {Object} params 参数
       * @param {boolean} params.status  是否关注
       * @param {string} params.id 用户id
       */
      setFollow: function setFollow(params) {
        this.call('view.followResultCallback', {
          status: params.status ? 1 : 0,
          blogId: params.id
        });
      },

      /**
       * 设置点赞点踩回调，更新native状态
       *
       * @param {Object} params 参数
       * @param {boolean} params.status  是否 1：增加 0 取消
       * @param {string} params.articleId 内容id
       * @param {string} params.action 行为 踩down 赞up
       * @param {number} params.upNum  赞数
       * @param {number} params.downNum 踩数
       *
       * @example
       * {
          "status": this.criticism ? 1 : 0,
          "articleId": this.item.id.toString(),
          "action": "down",
          "upNum": this.opdataPraise,
          "downNum": this.opdataCriticism
      }
       */
      setPraise: function setPraise(params) {
        this.call('view.praiseResultCallback', params);
      },

      /**
       * 客户端数据上报
       *
       * @param {Array} params 参数
       */
      setNormalAnalyticsInfo: function setNormalAnalyticsInfo(params) {
        this.call('view.setNormalAnalyticsInfo', params);
      },

      /**
       * 是否登录
       *
       * @returns {boolean}
       */
      isLogin: function isLogin() {
        return this.call('account.isLogin');
      },

      /**
       * 获取ios 是否在审核中
       *
       * @returns {boolean}
       */
      isSafeMode: function isSafeMode() {
        return this.call('account.isSafeMode');
      },

      /**
       * 获取Authorization
       *
       * @returns {string}
       */
      getAuthorization: function getAuthorization() {
        return this.call('account.getAuthorization') || '';
      },

      /**
       * 获取deviceId
       *
       * @returns {string}
       */
      getDeviceId: function getDeviceId() {
        return this.call('account.getDeviceId') || '';
      },

      /**
       * 获取timestamp
       *
       * @returns {string}
       */
      getTimestamp: function getTimestamp() {
        return this.call('account.getTimestamp');
      },

      /**
       * 获取版本号1.0.1
       *
       * @returns {string}
       */
      getVersion: function getVersion() {
        var versionNo = '1.0.0(1)';

        if (browser.app) {
          versionNo = dsBridge.call('account.getVersionNo');
        }

        return versionNo;
      },

      /**
       * 获取build号 1029
       *
       * @returns {string}
       */
      getBuildVersion: function getBuildVersion() {
        return this.call('account.getVersion');
      },

      /**
       * 获取用户加密码信息
       *
       * @returns {string}
       */
      getEncryptedUserName: function getEncryptedUserName() {
        return this.call('account.getEncryptedUserName');
      },

      /**
       * 注册事件  当前显示时调用
       *
       * @returns {Function} cb 页面显示时执行回调函数
       */
      visibilityappear: function visibilityappear() {
        var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
        this.register('visibilityappear', cb);
      },

      /**
       * 注册事件  当前隐藏时调用
       *
       * @returns {Function} cb 页面隐藏时执行回调函数
       */
      visibilitydisappear: function visibilitydisappear() {
        var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
        this.register('visibilitydisappear', cb);
      },

      /**
       * 跳转到app页面
       *
       * @param {string} path 跳转路径,以'/'开发
       */
      openPath: function openPath(path) {
        if (path.indexOf('/') !== 0) {
          path = '/' + path;
        }

        location.href = APP_CALL + path;
      },

      /**
       * 跳转到登录页面
       */
      toLogin: function toLogin() {
        this.openPath('/login');
      },

      /**
       * webview打开url
       * @param url  打开地址
       * @param from 打开来源
       */
      openUrl: function openUrl(url) {
        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'webview';

        if (/^https?:\/\//.test(url)) {
          this.openPath('/web?from=' + from + '&url=' + encodeURIComponent(url));
        }
      },

      /**
       * 获取appName
       * @returns {string}
       */
      getAppName: function getAppName() {
        var methodName = 'account.getAppName';
        var appName = '';

        if (this.hasMethod(methodName)) {
          appName = this.call(methodName) || '';
        }

        return encodeURIComponent(appName);
      },

      /**
       * 获取appName
       * @returns {string}
       */
      getChannel: function getChannel() {
        var methodName = 'account.getChannel';
        var appName = '';

        if (this.hasMethod(methodName)) {
          appName = this.call(methodName) || '';
        }

        return encodeURIComponent(appName);
      },

      /**
       * 获取用户id
       *
       * @returns {string}
       */
      getUserId: function getUserId() {
        return this.call('account.getUserId') || '';
      },

      /**
       * android 下载安装
       *
       * @param {Object} params 分享参数
       * @param {number} params.height
       */
      downloadApk: function downloadApk(params) {
        return this.call('view.downloadApk', params);
      },

      /**
       * view.sendNetworkRequest
       *
       * @param {Object} params
       * @param {string} params.method 方法 get,post
       * @param {string} params.path 路径 例如：/tron/sign，端加上路径：https://api-qa.beekuaibao.com/wallet/
       * @param {boolean} params.isSign 是否执行签名，默认为false,当传true是需要调起密码输入框
       * @param {boolean} params.trans 交易信息, 例如：['转账： 100 TRX', '收款地址：TE9JtDTevPaR6gtPyqK7BDVmiTkA1q8hdf']
       * @param {Object} params.body 方法为post时传入数据∂
       * @param {Function} cb  方法为post时传入数据∂
       * @returns {Promise}
       */
      sendNetworkRequest: function sendNetworkRequest(params, cb) {
        this.call('view.sendNetworkRequest', params, cb);
      },

      /*
      * 判断版本号是否大于某个版本
      *
      * @param {string} curV 比较版本
      * @param {string} reqV 参考版本 默认为当前版本
      * @returns {number} 比较结果 curV > reqV 为 1，curV = reqV 为 0，curV < reqV 为 -1
      *
       */
      compareVersion: function compareVersion(curV, reqV) {
        // curV 是否大于reqV
        if (!curV) {
          return 0;
        }

        if (!reqV) {
          var appVersion = this.getVersion();
          reqV = appVersion.split('(')[0];
        }

        var arr1 = curV.split('.');
        var arr2 = reqV.split('.'); //将两个版本号拆成数字

        var minL = Math.min(arr1.length, arr2.length);
        var pos = 0; //当前比较位

        var diff = 0; //当前为位比较是否相等
        //逐个比较如果当前位相等则继续比较下一位

        while (pos < minL) {
          diff = parseInt(arr1[pos]) - parseInt(arr2[pos]);

          if (diff !== 0) {
            break;
          }

          pos++;
        }

        if (diff > 0) {
          return 1;
        } else if (diff === 0) {
          return 0;
        } else {
          return -1;
        }
      }
    };
  }
  /**
   * @file 币快报前端接口
   * @author maofaming(229894116@qq.com)
   */


  function requestGenerate() {
    var _detectGenerate = detectGenerate(),
        browser = _detectGenerate.browser;

    var sdk = sdkGenerate();

    var _getConfig = getConfig(),
        API_ENV = _getConfig.API_ENV,
        COMMON_ENV = _getConfig.COMMON_ENV,
        HEADER_KEY = _getConfig.HEADER_KEY,
        METHOD = _getConfig.METHOD,
        DEFAULT_PATH_MAP = _getConfig.DEFAULT_PATH_MAP,
        DEFAULT_SPACE = _getConfig.DEFAULT_SPACE;

    var commonHeaders = {
      'Content-Type': 'application/json'
    }; // 后台做了非微信浏览器且一定要有Id存在
    // 本地调试用随机数

    if (browser.app) {
      // 设置Authorization
      commonHeaders[HEADER_KEY.AUTH] = sdk.getAuthorization(); // 设置deviceId

      commonHeaders[HEADER_KEY.DEVICE] = sdk.getDeviceId(); // 设置timestamp

      commonHeaders[HEADER_KEY.TS] = sdk.getTimestamp(); // 设置Version

      commonHeaders[HEADER_KEY.VERSION] = sdk.getVersion(); // 设置appName

      commonHeaders[HEADER_KEY.APP] = sdk.getAppName(); // 设置系统类型

      if (browser.android) {
        commonHeaders[HEADER_KEY.TYPE] = 'android';
      }

      if (browser.ios) {
        commonHeaders[HEADER_KEY.TYPE] = 'ios';
      }
    } else {
      commonHeaders[HEADER_KEY.TYPE] = 'h5';
    }
    /**
     * @constructor
     */


    var Request = function () {
      /**
       * 初始化请求接口 设置参数
       * @param {Object} params 分享参数
       * @param {string} params.domain 请求域名
       * @param {object} params.domainMap 环境与域名解析关系
       * @param {string} params.basePath 路径
       * @param {string} params.pathMap 默认路径参数
       * @param {number} params.timeout 超时时间
       * @param {string} params.env 运行环境
       * @param {string} params.protocol 请求协议
       * @param {function} params.before 请求发出前处理函数（钩子）
       * @param {function} params.after 请求完成后处理函数（钩子）
       */
      function Request(_ref) {
        var domain = _ref.domain,
            domainMap = _ref.domainMap,
            _ref$basePath = _ref.basePath,
            basePath = _ref$basePath === undefined ? DEFAULT_SPACE : _ref$basePath,
            _ref$pathMap = _ref.pathMap,
            pathMap = _ref$pathMap === undefined ? DEFAULT_PATH_MAP : _ref$pathMap,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 10000 : _ref$timeout,
            _ref$env = _ref.env,
            env = _ref$env === undefined ? API_ENV : _ref$env,
            protocol = _ref.protocol,
            before = _ref.before,
            after = _ref.after;
        classCallCheck(this, Request);
        this.domainMap = domainMap || this.getDomainMap(domain);
        this.domain = this.getDomain(env);
        this.pathMap = this.getPathMap(pathMap);
        this.basePath = this.getPath(basePath, this.pathMap);
        this.timeout = timeout;
        this.instance = axios.create({
          baseURL: this.basePath,
          timeout: this.timeout
        });

        if (!protocol) {
          if (isBrowser()) {
            this.protocol = location.protocol;
          } else {
            this.protocol = 'http:';
          }
        } else {
          this.protocol = protocol;
        }

        if (before) {
          // Add a request interceptor
          this.instance.interceptors.request.use(function (config) {
            // Do something before request is sent
            return before(config);
          }, function (error) {
            // Do something with request error
            return Promise.reject(error);
          });
        }

        if (after) {
          // Add a response interceptor
          this.instance.interceptors.response.use(function (response) {
            // Do something with response data
            return after(response);
          }, function (error) {
            // Do something with response error
            return Promise.reject(error);
          });
        }

        this.instance.defaults.headers.post['Content-Type'] = 'application/json';
        this.instance.defaults.withCredentials = true;
      }
      /**
       * 根据环境获取域名
       * @param {string} env
       * @returns {object}
       * @private
       */


      createClass(Request, [{
        key: "getDomain",
        value: function getDomain(env) {
          return this.domainMap[env];
        }
        /**
         * 获取环境域名关系
         * @param {string} domain
         * @returns {object}
         * @private
         */

      }, {
        key: "getDomainMap",
        value: function getDomainMap(domain) {
          var _ref2;

          var pos = domain.indexOf('.');
          var pre = domain.substring(0, pos);
          var main = domain.substring(pos);
          return _ref2 = {}, defineProperty(_ref2, COMMON_ENV.DEV, pre + '-dev' + main), defineProperty(_ref2, COMMON_ENV.QA, pre + '-qa' + main), defineProperty(_ref2, COMMON_ENV.PRE, pre + '-pre' + main), defineProperty(_ref2, COMMON_ENV.PRD, pre + '' + main), _ref2;
        }
        /**
         * 设置默认路径
         * @param {object} pathMap
         * @returns {object}
         * @private
         */

      }, {
        key: "getPathMap",
        value: function getPathMap(pathMap) {
          var map = {};

          if (isBrowser()) {
            map = urlParse(location.search.substring(1)); // qs.parse()
          }

          return _extends({}, pathMap, map);
        }
        /**
         * 解析路径
         * @param {string} path
         * @param {object} params
         * @returns {string}
         * @private
         */

      }, {
        key: "getPath",
        value: function getPath(path, params) {
          if (!/^\//.test(path)) {
            path = '/' + path;
          }

          if (params) {
            return path.replace(/{(\w+)}/g, function ($0, $1) {
              var key = $1.trim();

              if (params[key]) {
                return params[key];
              } else {
                return $1;
              }
            });
          } else {
            return path;
          }
        }
        /**
         * 设置请求参数
         * @param {string} method 请求方法
         * @param {string} path 路径
         * @param {object} params 路径参数
         * @param {object} query 查询参数
         * @param {object} body 请求体
         * @param {object} headers 请求header设置
         * @param {number} timeout 超时时间
         * @param {boolean} cache 是否缓存请求
         * @returns {object} 请求参数结果
         */

      }, {
        key: "setConfig",
        value: function setConfig$$1(_ref3) {
          var method = _ref3.method,
              path = _ref3.path,
              _ref3$params = _ref3.params,
              params = _ref3$params === undefined ? {} : _ref3$params,
              query = _ref3.query,
              _ref3$body = _ref3.body,
              body = _ref3$body === undefined ? {} : _ref3$body,
              _ref3$headers = _ref3.headers,
              headers = _ref3$headers === undefined ? {} : _ref3$headers,
              timeout = _ref3.timeout,
              cache = _ref3.cache;
          var config = {
            method: method || 'get',
            url: this.protocol + '//' + this.domain + this.getPath(this.basePath + path, params)
          };

          if (timeout) {
            config.timeout = timeout;
          }

          if (query) {
            var queryStr = urlStringify(query); // qs.stringify(query)

            if (queryStr) {
              config.url += '?' + queryStr;
            }
          }

          if (typeof cache === 'boolean' && !cache) {
            var cacheStr = '_=' + Math.random().toString().substring(2);
            config.url += (config.url.indexOf('?') > 0 ? '?' : '&') + cacheStr;
          }

          if (method === METHOD.PUT || method === METHOD.POST || method === METHOD.PATCH) {
            config.data = body;
          }

          if (browser.app) {
            var _babelHelpers$extends;

            config.headers = _extends({}, commonHeaders, (_babelHelpers$extends = {}, defineProperty(_babelHelpers$extends, HEADER_KEY.AUTH, sdk.getAuthorization()), defineProperty(_babelHelpers$extends, HEADER_KEY.TS, sdk.getTimestamp()), _babelHelpers$extends), headers);
          } else {
            config.headers = _extends({}, commonHeaders, headers);
          }

          return config;
        }
        /**
         * 执行请求
         * @param {object} params 请求参数
         * @returns {Promise<any>}
         */

      }, {
        key: "create",
        value: function create(params) {
          var _this = this;

          var config = this.setConfig(params);
          return new Promise(function (resolve, reject) {
            try {
              _this.instance.request(config).then(function (data) {
                if (data.status === 200 && (data.data.errCode === 0 || data.data.code === 0)) {
                  resolve(data.data.data);
                } else {
                  reject(data.data);
                }
              }).catch(function (error) {
                console.error(error);
                reject({
                  errCode: -2,
                  errMsg: error.message
                });
              });
            } catch (e) {
              console.error(e);
              reject({
                errCode: -3,
                errMsg: e.message
              });
            }
          });
        }
        /**
         * GET 方法
         * @param params
         * @returns {Promise<any>}
         */

      }, {
        key: METHOD.GET,
        value: function value(params) {
          var map = {};

          if (typeof params === 'string') {
            map = {
              path: params
            };
          } else if (params && params.path) {
            map = params;
          }

          return this.create(_extends({
            method: METHOD.GET
          }, map));
        }
        /**
         * PUT 方法
         * @param params
         * @returns {Promise<any>}
         */

      }, {
        key: METHOD.PUT,
        value: function value(params) {
          var map = {};

          if (typeof params === 'string') {
            map = {
              path: params
            };
          } else if (params && params.path) {
            map = params;
          }

          return this.create(_extends({
            method: METHOD.PUT
          }, map));
        }
        /**
         * POST 方法
         * @param params
         * @returns {Promise<any>}
         */

      }, {
        key: METHOD.POST,
        value: function value(params) {
          var map = {};

          if (typeof params === 'string') {
            map = {
              path: params
            };
          } else if (params && params.path) {
            map = params;
          }

          return this.create(_extends({
            method: METHOD.POST
          }, map));
        }
        /**
         * DELETE 方法
         * @param params
         * @returns {Promise<any>}
         */

      }, {
        key: METHOD.DELETE,
        value: function value(params) {
          var map = {};

          if (typeof params === 'string') {
            map = {
              path: params
            };
          } else if (params && params.path) {
            map = params;
          }

          return this.create(_extends({
            method: METHOD.DELETE
          }, map));
        }
      }]);
      return Request;
    }();

    return Request;
  }
  /**
   * bitwires基础组件
   * @external bit-util
   * @see module:util/index
   * @see module:util/format
   * @see module:util/validator
   */


  function utilGenerate(param) {
    var config = setConfig(param);
    var detect = detectGenerate();
    var sdk = sdkGenerate();
    var Request = requestGenerate();
    return {
      util: util,
      dateFormat: dateFormat,
      detect: detect,
      sdk: sdk,
      Request: Request,
      version: version,
      validator: validator,
      config: config
    };
  }

  exports.utilGenerate = utilGenerate;
  exports.default = utilGenerate;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});